import { render, staticRenderFns } from "./DocutaxRequestForClient.vue?vue&type=template&id=0396abfa&"
import script from "./DocutaxRequestForClient.vue?vue&type=script&lang=js&"
export * from "./DocutaxRequestForClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports